import React from "react";
import ReactDOM from "react-dom";
import PostcodeModal from "./components/Postcode/PostcodeModal";
import { SetPopupStartTime } from "./components/WebStorage";

SetPopupStartTime();

//Postcode
const pc = document.getElementById("pc");
if (pc) {
  ReactDOM.render(<PostcodeModal content={window["PC_Content"]} />, pc);
}
